<template>
  <div class="search" :class="searchList.length > 4 ? '' : 'ht'">
    <div class="search_top">
      <!-- 头部 -->
      <hearderCommon :text="textT"></hearderCommon>
      <!-- 搜索框 -->
      <van-search
        class="v-search"
        v-model="value"
        placeholder="请输入搜索关键词"
        show-action
        shape="round"
        v-focus
        background="#F2F2F2"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch" class="d-div">搜索</div>
      </van-search>
    </div>
    <p class="clearH" v-if="showSearchHistory">
      <span class="clearH">历史记录</span>
      <van-icon class="his" name="close" size="18px" @click="clearHis" />
    </p>
    <!-- 历史搜索 -->
    <div v-if="showSearchHistory" class="his-d">
      <van-tag
        v-for="item in searchHistory"
        :class="item.length < 3 ? 'padd' : ''"
        :key="item"
        @click="CTag(item)"
        class="van-tag"
        round
        color="#DDDDDD"
        text-color="#666666"
        size="large"
        >{{ item }}</van-tag
      >
    </div>
    <!-- 搜索列表 -->
    <div class="searchList">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <CommonList
            :List="searchList"
            @Guige="showGuige"
            @JiBu="JiBu(arguments)"
            @remarK="remarK(arguments)"
            @removeAll="removeAll(arguments)"
            @addRemark="addRemark(arguments)"
            @DanAdd="DanAdd(arguments)"
            @DanAllRem="DanAllRem(arguments)"
            @DanRem="DanRem(arguments)"
            @Dia="Dia(arguments)"
            @DiaDan="DiaDan(arguments)"
            @sPop="sPop(arguments)"
            @sPopDan="sPopDan(arguments)"
          ></CommonList>
        </van-list>
      </van-pull-refresh>
      <!-- 无搜索结果 -->
      <div v-if="noSearchList">
        <img src="../../assets/搜索.png" alt class="noList" />
        <p class="search-p">暂无搜索结果</p>
      </div>
    </div>
  </div>
</template>

<script>
import CommonList from "../common/searchList";
import hearderCommon from "../common/headerCommon";

export default {
  created() {
    this.customerId = localStorage.getItem("customerId");
    const searchValue = localStorage.getItem("searchValue");
    this.value = searchValue;
    if (searchValue) {
      this.onSearch();
    }
    // 获取历史搜索
    this.getHis();
  },
  components: {
    CommonList,
    hearderCommon,
  },
  data() {
    return {
      searchHistory: [],
      value: "",
      loading: false,
      refreshing: false,
      page: {
        current: 1,
        size: 20,
        total: 0,
      },
      finished: false,
      showTag: true,
      showSearchHistory: true,
      customerId: "",
      showClearH: true,
      showAdd: true,
      searchList: [],
      showRemark: false,
      showPopup: false,
      remark: "",
      goodNum: 1,
      showStep: false,
      noSearchList: false,
      showDia: false,
      GoodsDto: {},
      balck: "",
      textT: "搜索",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.getHis();
        if (!val) {
          (this.showSearchHistory = true),
            (this.noSearchList = false),
            (this.searchList = []);
        }
      },
    },
    deep: true,
  },
  methods: {
    // 获取历史搜索
    getHis() {
      this.$axios
        .get(
          `/trade/tradeSearch/history?customerId=${this.customerId}&limit=20`
        )
        .then((res) => {
          this.searchHistory = res.data.data;
        });
    },
    onRefresh() {
      setTimeout(() => {
        this.refreshing = false;
      }, 500);
    },
    async onLoad() {
      const params = {
        customerId: this.customerId,
        param: decodeURIComponent(this.value),
      };
      this.page.current += 1;
      const res = await this.$axios.post(
        `/trade/tradeOrder/search/price/page?current=${
          this.page.current
        }&size=${20}`,
        params
      );
      let data = res.data.data;
      this.page = {
        current: data.current,
        total: data.total,
        size: data.size,
      };
      if (data.records.length <= 0) {
        this.finished = true;
      }
      this.searchList.push(...data.records);
      this.loading = false;
      this.searchList.forEach((item) => {
        this.$set(item, "showGuiGe", false);
        item.children.forEach((index) => {
          if (index.remark) {
            this.$set(index, "remark", index.remark);
          } else {
            this.$set(index, "remark", "");
          }
          this.$set(index, "showRemark", false);
          this.$set(index, "showPop", false);
          this.$set(index, "showDia", false);
          this.$set(index, "newOrderQty", index.orderQty);
          this.$set(index, "newRemark", index.remark);
        });
      });
    },
    //   搜索功能
    async onSearch() {
      this.showTag = this.showClearH = this.finished = false;
      this.showSearchHistory = !this.value;
      const params = {
        customerId: this.customerId,
        param: decodeURIComponent(this.value),
      };
      const res = await this.$axios.post(
        `/trade/tradeOrder/search/price/page?current=${1}&size=${20}`,
        params
      );
      let data = res.data.data;
      if (data !== null) {
        this.searchList = data.records;
        this.page = {
          current: data.current,
          total: data.total,
          size: data.size,
        };
        this.searchList.forEach((item) => {
          this.$set(item, "showGuiGe", false);
          item.children.forEach((index) => {
            if (index.remark) {
              this.$set(index, "remark", index.remark);
            } else {
              this.$set(index, "remark", "");
            }
            this.$set(index, "showRemark", false);
            this.$set(index, "showPop", false);
            this.$set(index, "showDia", false);
            this.$set(index, "newOrderQty", index.orderQty);
            this.$set(index, "newRemark", index.remark);
          });
        });
      } else {
        this.searchList = [];
      }
      this.noSearchList = this.searchList.length === 0;
    },
    // 添加商品方法
    async addGood(Goods) {
      this.GoodsDto = {
        ...Goods,
        customerId: this.customerId,
        orderQty: this.goodNum,
        remark: this.remark,
        skuId: Goods.skuId,
      };
      const res = await this.$axios.post(
        "/trade/tradeCart/save",
        this.GoodsDto
      );
      res;
    },
    // 清除历史记录
    clearHis() {
      this.$axios
        .delete(`/trade/tradeSearch?customerId=${this.customerId}`)
        .then(() => {
          this.getHis();
        });
    },
    // 回退
    returnB() {
      window.history.back();
    },
    // 历史记录搜索
    CTag(item) {
      this.value = item;
      this.onSearch();
    },
    // 显示规格列表
    showGuige(id) {
      let guige = this.searchList.find((item) => item.goodsId == id);
      guige.showGuiGe = !guige.showGuiGe;
    },
    // 显示进步器
    JiBu(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = 1;
      son.orderQty = 1;
      son.showRemark = true;
    },
    // 多规格数量输入
    Dia(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.showDia = true;
      son.newOrderQty = son.orderQty;
    },
    // 显示备注框
    remarK() {
      // console.log(rs);
    },
    // 单规格输入
    DiaDan(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.showDia = true;
      son.newOrderQty = son.orderQty;
    },
    // 删除所有商品
    removeAll(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = 0;
      son.orderQty = 0;
    },
    // 添加备注
    addRemark(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.remark = rs[2];
    },
    // 多规格显示备注
    sPop(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.showPop = true;
      son.newRemark = son.remark;
    },
    // 单规格显示备注
    sPopDan(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.showPop = true;
      son.newRemark = son.remark;
    },
    // 单规格添加
    DanAdd(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = 1;
      son.showRemark = true;
      son.orderQty = 1;
    },
    // 单规格删除全部
    DanAllRem(rs) {
      let far = this.searchList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = 0;
      son.orderQty = 0;
      // son.showRemark = true;
    },
  },
};
</script>

<style scoped>
.search_top {
  position: fixed;
  width: 100%;
  z-index: 999;
  top: 0;
  left: 0;
}
header {
  padding-top: 5px;
  padding-bottom: 5px;
  background: rgb(233, 233, 233);
  padding-left: 2%;
}
.ht {
  height: 100%;
}
.search {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  padding: 2%;
  background: rgba(242, 242, 242, 1);
  padding-top: 100px;
  box-sizing: border-box;
}
.v-search {
  background: rgba(242, 242, 242, 1);
  width: 95%;
  padding: 5px;
  position: fixed;
  top: 40px;
}
h3 {
  text-align: center;
}
.header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  background: transparent;
}
.i {
  margin: 5px;
}
.clearH {
  margin: 12px;
  line-height: 20px;
  position: relative;
}
.his {
  position: absolute;
  right: 0;
  top: 2px;
  font-weight: 700;
}
.clearH {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.van-tag {
  margin: 5px;
}
.padd {
  padding: 2.8px 16px;
}
.his-d {
  padding-left: 15px;
}
.header {
  width: 60px;
}
.noList {
  width: 100%;
  height: 100%;
  margin-top: 100px;
}
.search-p {
  text-align: center;
}
.van-icon {
  top: 2px;
}
.v-search {
  padding: 10px 0 10px 4% !important;
  width: 100%;
}
</style>